import { Stack, Typography } from "@mui/material";

export const NoContentBlock = ({
  title,
  text,
}: {
  title: string;
  text: string;
}) => {
  return (
    <Stack gap="8px" alignItems="center" justifyContent="center" flexGrow={1}>
      <Typography
        variant="subtitle1"
        color="custom.textDarkBlue"
        textAlign="center"
        fontWeight={500}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        textAlign="center"
        maxWidth="382px"
      >
        {text}
      </Typography>
    </Stack>
  );
};
